import { post } from '../base';

export const useReferralCode = () => {
  const validateReferralCode = (referralCode) =>
    post(`referrals/${referralCode}`);

  return {
    validateReferralCode,
  };
};
